import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { PaddedText, StyledSavedIcon, StyledSavingIcon } from './styles'

interface Props {
	isSaving: boolean
}

const AutoSaveIndicator: React.FC<Props> = ({ isSaving }) => {
	const { t } = useTranslation()
	return (
		<Box display="flex" alignItems="center" pr={2}>
			<PaddedText variant="body2">
				{isSaving ? t('autosave.savingChanges') : t('autosave.changesSaved')}
			</PaddedText>
			{isSaving ? <StyledSavingIcon /> : <StyledSavedIcon />}
		</Box>
	)
}

export { AutoSaveIndicator }
